var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stripe-pricing-table',{attrs:{"pricing-table-id":"prctbl_1NaHtRJuGEa1CQeZrSifatIo","publishable-key":"pk_live_51LpqwKJuGEa1CQeZwYt0YniOFru3bD1zbrfaYSm7rPRFEyleb32RoIlt1DvBKaevquc8fJMn7i79EycM9E5vsokU00Cv2T6tMQ"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }